import React from "react";
import "./GotoCartModal.css";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Green_Btn from "../../common_btn/green_btn/Green_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import Common_Goto_Cart_Card from "../../common_goto_cart_card/Common_Goto_Cart_Card";

function GotoCartModal(props) {

    const navigate = useNavigate()


    return (
        <>
            <section className="GotoCartModal modal-holder">
                <Modal
                    {...props}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className="GotoCartModal modal-holder"
                >

                    <Modal.Body>
                        <Common_Goto_Cart_Card closeModal={() => {props?.onHide()}}/>
                    </Modal.Body>
                </Modal>
            </section>
        </>
    );
}

export default GotoCartModal;
